import { View } from 'react-native';
import {
  COLOR,
  FONT_SIZE,
  FONT_WEIGHT,
  SPACING,
} from 'constants/design-system';

import { BaseIcon } from 'components/BaseIcon';
import { BaseText } from 'components/BaseText';

import type { BaseIconProps } from 'components/BaseIcon';
import type { BaseTextProps } from 'components/BaseText';
import type { DiscriminatedPick } from 'util/types/discriminated-pick';

export type CardHeaderSectionProps = {
  title: string;
  color?: BaseTextProps['color'];
  icon?: DiscriminatedPick<BaseIconProps, 'name' | 'variant'>;
};

export const CardHeaderSection = (props: CardHeaderSectionProps) => {
  const { title, color, icon } = props;

  return (
    <View>
      <View
        style={{
          flexDirection: 'row',
          gap: SPACING.theme[4],
          alignItems: 'flex-start',
          padding: SPACING.theme[2],
        }}
      >
        {icon && <BaseIcon {...icon} color={color} size={FONT_SIZE.theme.lg} />}
        <BaseText
          color={color}
          fontWeight={FONT_WEIGHT.theme.bold}
          fontSize={FONT_SIZE.theme.xs}
          style={{
            flex: 1,
          }}
        >
          {title}
        </BaseText>
      </View>
      <View
        style={{
          height: 1,
          backgroundColor: COLOR.theme.gray[300],
          marginTop: SPACING.theme[4],
        }}
      />
    </View>
  );
};
